module.exports = __webpack_public_path__ + "static/media/linkedin-learning-white.42929715.svg";